import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TypoTitle from "./typoTitle";
import TypoSession from "./typoSession";
import PickerDateRange from "./pickerDateRange";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
const styles = {
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  button: {
    marginLeft: "1rem",
  },
  containerRight: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  backFrame: {
    display: "flex",
    color: "#546d7a",
    alignItems: "center",
    cursor: "pointer",
  },
  backIconStyle: {
    marginBottom: "0.35em",
    height: "1.1rem",
  },
};
class Header extends React.Component {
  actionBack = (linkToBack, push) => {
    push(linkToBack);
  };
  render() {
    const {
      classes,
      session = "",
      title = "",
      button = "",
      colorButton = "",
      actionButton = "",
      variant = "",
      handleFilterDate,
      showFilterDate = false,
      from = "",
      to = "",
      renderActionCustom = "",
      backIcon = "",
      actionBack = "",
      titleToolipIconDateRange,
    } = this.props;
    return (
      <div className={classes.frameTitle}>
        <div>
          {backIcon && actionBack ? (
            <div
              className={classes.backFrame}
              onClick={actionBack}
              style={{ cursor: "pointer" }}
            >
              <ArrowBackIosIcon className={classes.backIconStyle} />
              <TypoSession gutterBottom>{session}</TypoSession>
            </div>
          ) : (
            <TypoSession gutterBottom>{session}</TypoSession>
          )}
          <TypoTitle gutterBottom>{title}</TypoTitle>
        </div>
        <div className={classes.containerRight}>
          {showFilterDate && handleFilterDate && (
            <PickerDateRange
              from={from}
              to={to}
              handleFilterDate={handleFilterDate}
              titleToolip={titleToolipIconDateRange}
            />
          )}
          {button && (
            <Button
              className={classes.button}
              variant={variant || "contained"}
              color={colorButton || "primary"}
              onClick={actionButton}
            >
              {button}
            </Button>
          )}

          {renderActionCustom && renderActionCustom()}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  // onChange: PropTypes.func.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(Header)));
